import { z } from "zod";

export const zScreenState = {
  audioMuted: z.boolean(),
  theme: z.enum(["light", "dark"]).optional(),
  currentLanguage: z.string().optional(),
  currentBreakpoint: z.string().optional(),
  zoomMode: z.string().optional(),
  zoomValue: z.number().optional(),
  stagePosition: z
    .object({ x: z.number(), y: z.number() })
    .nullable()
    .optional(),
  helpers: z
    .object({
      rulers: z.boolean().optional(),
      snap: z.boolean().optional(),
      guides: z.boolean().optional(),
      dots: z.boolean().optional(),
      lines: z.boolean().optional(),
      overlay: z.boolean().optional(),
    })
    .optional(),
  sketchEraserMode: z.enum(["delete", "delete-clean"]).optional(),
  sketchSelectionMode: z.enum(["marquee", "lasso"]).optional(),
};

export const zAudioMuted = z.boolean();
export const zTheme = z.enum(["light", "dark"]);
export const zZoomValue = z.number();
export const zZoomMode = z.string();
export const zStagePosition = z.object({ x: z.number(), y: z.number() });
export const zHelpers = z.object({
  rulers: z.boolean().optional(),
  snap: z.boolean().optional(),
  guides: z.boolean().optional(),
  dots: z.boolean().optional(),
  lines: z.boolean().optional(),
  overlay: z.boolean().optional(),
});
export const zCurrentLanguage = z.string();
export const zCurrentBreakpoint = z.string();
export const zSelectedMode = z.enum(["sketch", "edit", "ds", "cms"]);
export const zSelectedTool = z.string().nullable().optional();
export const zHandedness = z.enum(["left", "right"]);
export const zSketchEraserMode = z.enum(["delete", "delete-clean"]);
export const zSketchSelectionMode = z.enum(["marquee", "lasso"]);
